export const SITE = {
  url: 'https://renosheets.com',
  name: 'RenoSheets',
  tagline: 'Measure twice. Calculate once.',
  disclaimer:
    'All calculations are estimates for planning purposes only. RenoSheets does not provide professional advice.',
}
